// Misc
import { Component, createElement } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

// Atoms
import Link from './Link'

export default
@withRouter
class GoBackButton extends Component {
  static propTypes = {
    defaultTo: PropTypes.string,
    history: PropTypes.object.isRequired,
    location: PropTypes.any,
    match: PropTypes.any,
    staticContext: PropTypes.any,
    component: PropTypes.any,
  }

  static defaultProps = {
    defaultTo: '/',
    component: Link,
  }

  handleClick = (ev) => {
    const { history } = this.props
    if (history.length > 1) {
      ev.preventDefault()
      history.goBack()
    }
  }

  render() {
    const { component, history, match, location,
      staticContext, defaultTo, ...rest } = this.props
    return createElement(component, {
      ...rest,
      to: defaultTo,
      onClick: this.handleClick
    })
  }
}
